// src/engine/CDN.js
// One file. One domain. One truth.
//
// ANNIHILATION's assets live on their own Pages project — NEVER the
// app domain. The app domain is an SPA catch-all: a bad image URL
// pointed there returns HTML instead of a 404, which is a far more
// confusing bug to chase. Confirm the domain before debugging any
// missing image.
export const CDN = "https://annihilation-assets.pages.dev";
export const cdnUrl = (filename) => `${CDN}/${filename}`;

// Kept for engine import compatibility (SpriteManifest & friends may
// import it from the master). Annihilation has no cards — dormant
// exports cost nothing; broken imports cost a build.
export const cardUrl = (cardId) => `${CDN}/${cardId}.webp`;
